import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import cx from 'classnames';

import { getTypeFromUrl } from 'utils/media';
import { FileType } from 'constants/constants';

import { getSceneStyle, isTransparent } from 'store/models/Scene';
import { ImageSlide, VideoSlide } from 'components/Slide';


class Slideshow extends React.Component {
  static defaultProps = {
    settings: { length: 5000 },
  }

  state = {
    index: -1,
    playing: false,
    timer: null,
  }

  play = index => !_.isNil(index)
    ? this.setState({ index: index - 1 }, () => this.onSceneChange(true))
    : this.onSceneChange(true);

  stop = () => {
    clearTimeout(this.state.timer);
    this.setState({ playing: false, });
  }

  show = index => {
    let { scenes, onSlideChanged } = this.props;
    if(_.isNil(index))
      return;

    this.setState({ 
      index: index, 
      playing: true 
    });

    let scene = scenes[index];
    onSlideChanged?.(index, scene);
  }

  onSceneChange = (startImmediately) => {
    let { scenes, onSlideChanged, onBreak, overlaySettings, sceneSettings } = this.props;
    let { index, timer } = this.state;

    clearTimeout(timer);
    if(!scenes || !scenes.length)
      return;

    // GET NEXT SCENE
    let next = (index + 1) % scenes.length;
    let nextScene = scenes[next];
    let length = sceneSettings?.[nextScene._id]?.settings.length;
    let slideBreakLength = sceneSettings?.[nextScene._id]?.settings?.slideBreak ?? overlaySettings?.slideBreak;
    let loopBreakLength = overlaySettings?.pause
    let breakLength = next === 0 
      ? loopBreakLength || slideBreakLength
      : slideBreakLength;
    let doSlideBreak = breakLength > 0;

    // DO SLIDE OR LOOP BREAK IF DEFINED
    if(!startImmediately && doSlideBreak) {
      timer = setTimeout(() => this.onSceneChange(true), breakLength);
      onBreak?.(next, nextScene, breakLength);
      this.setState({ 
        playing: false, 
        index, 
        timer,
      });
      return;
    }

    // START NEXT SCENE
    timer = setTimeout(this.onSceneChange, length);
    onSlideChanged?.(next, nextScene, length);
    this.setState({ 
      playing: true, 
      index: next, 
      timer, 
    });
  }

  componentWillUnmount() {
    let { timer } = this.state;
    clearTimeout(timer);
  }

  render() {
    let { scenes, sceneSettings } = this.props;
    let { index, playing } = this.state;
    let selected = scenes?.[index];
    let style = !_.isNil(index) && playing
      ? getSceneStyle(sceneSettings?.[selected?._id]?.settings) 
      : null;
    let isTrans = isTransparent(sceneSettings?.[selected?._id]?.settings)
    return (
    <div className={cx("g-slideshow", { 'slide-no-background': isTrans })} style={style}>
      { _.map(scenes, (scene,i) => {
        let type = getTypeFromUrl(scene.url);
        let showSlide = (index === i) && playing;
        switch(type) {
          case FileType.VIDEO:
            return (
              <VideoSlide 
                key={scene._id} 
                scene={scene}
                show={showSlide} />)
          default:
            return (
              <ImageSlide
                key={scene._id} 
                scene={scene}
                show={showSlide} />)
        }
      }) }
    </div>);
  }
}

  export default Slideshow;

